"use client";
import React from 'react';
import PropTypes from 'prop-types';
import Onetime from './oneTime';

export default function NoServiceAgreement({ labels, inactiveCustomerInvoice, paymentsCss, invoiceStatuses }) {
  const { lockedServiceAmountDue, contact, contactLink } = labels;
 
  /* invoice status */
  let invoices = [inactiveCustomerInvoice];
  
  const isProcessing = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.processing.includes(invoice.invoiceNum)) : false;
  const isFailed = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.failed.includes(invoice.invoiceNum)) : false;
  const isNotFound = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.not_found.includes(invoice.invoiceNum)) : false;
  const isOnQueue = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.onqueue.includes(invoice.invoiceNum)) : false;
  const isPending = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.pending.includes(invoice.invoiceNum)) : false;
  const isSuccess = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.success.includes(invoice.invoiceNum)) : false;
  const isActionEnabled = !(isProcessing || isOnQueue || isPending || isSuccess);
  
  return (
    <div className='row'>
      <div className='col-12'>
          <div className={`row ${paymentsCss["mb-16"]} ${paymentsCss["tru-mma-main-content-box"]}`}>
            <div
              className={`col-12 col-md-8 col-lg-9 ${paymentsCss["gfw-3"]} ${paymentsCss["p-30"]} text-center ${paymentsCss["text-md-left"]} ${paymentsCss["tru-mma-main-content"]}`}>
              <div className='mb-10'>
                <span className={`d-block ${paymentsCss["gfs-24"]} ${paymentsCss["gfs-lg-30"]} glh-1 mb-10`}>
                  Outstanding invoice
                </span>
              </div>
              <div className="row">
                <div className="col-1 pt-2">
                  <img src='/images/MyAccount/Icons/error-notification-icon.png' className='' alt='Temporarily Locked' width='25' />
                </div>
                <div className="col-11" style={{marginLeft: '-15px'}}>
                  <span className={`${paymentsCss["gfs-14"]} ${paymentsCss["gfw-4"]}`}>
                    {lockedServiceAmountDue} <a href={contactLink} className={`text-green ${paymentsCss["js-phoneno"]}`}>{contact}</a>
                  </span>
                </div>
              </div>
            </div>
            <Onetime isActionEnabled={isActionEnabled} arBalance={inactiveCustomerInvoice.invoiceBalance} labels={labels} paymentsCss={paymentsCss} />
          </div>
      </div>
    </div>
  );
}

NoServiceAgreement.propTypes = {
  labels: PropTypes.object.isRequired,
  inactiveCustomerInvoice: PropTypes.object.isRequired
};